import React, { Component } from 'react';
import { translate } from '../../utils/useful';
import FormViewer from '../../components/FormViewer';
import CustomLoader from '../../components/CustomLoader';
import StagesManager from '../../components/StagesManager';
import HttpServices from '../../utils/Http.services';
import moment from 'jalali-moment';

class RoomSchedule extends Component {
    state = {
        allDays: true,
        scheduleList: [
            // { name: 'Paityn Carder & Livia Culhane', time: '2Jun,2022 17:30' },
            // { name: 'Paityn Carder & Livia Culhane', time: '2Jun,2022 17:30' },
            // { name: 'Paityn Carder & Livia Culhane', time: '2Jun,2022 17:30' },
        ]
    }
    componentDidMount() {
        this.init()
    }

    init = () => {
        console.log('appletprops', this.props)
        HttpServices.request('getRoomSchedules', { frame: this.props.page?._id, applet: this.props.applet?._id }, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            // console.log('fetchResult.infosc',fetchResult.info)
            this.setState({ scheduleList: fetchResult.info })

        })
    }

    changePage = (stage) => {
        this.stageManager.changeStage(stage)
    }

    render() {
        return (
            <div className=' window-content-radius scroll-no-scrollbar h-100' style={{ backgroundColor: '#f5f5f5' }}>
                <div className='p-5'>
                    <div className='w-100 flexcb pb-3'>
                        <h2 className="font-size-25 main-c3" >{translate('rooms.Schedule')}</h2>
                        <button className="flexc px-2" onClick={() => { this.props.changePage('newschedule') }}>
                            <img src="/assets/icons/rooms/plus-purple.svg" className="" width={24} />
                            <p className="font-size-14" style={{ color: '#7064FE' }}>{translate("rooms.New schedule")}</p>
                        </button>
                    </div>
                    <p className="mt-1 font-size-14 main-c7" >{translate('What is a hub? Lorem ipsum dolor sit amet consectetur, adipisicing elit. Incidunt iure mollitia illo et, id deleniti magnam necessitatibus. Expedita ad, numquam voluptatum autem atque dignissimos laboriosam. Culpa enim quod maxime asperiores.')}</p>
                    <div className='flexc mt-3'>

                    </div>
                    <div className='pt-4' >
                        <p className='font-size-15 weight-500 pld-2' style={{}}>{translate('rooms.Schedule meetings')}</p>
                        {this.state.scheduleList.map((item, index) => {
                            return (
                                <div className='w-100 px-3 py-2 br-10 flexcb shadow-2 mt-3' style={{ backgroundColor: '#fff' }}>
                                    <div className='flexc'>
                                        <div className='br-10 mrd-3 '>
                                            {item.title ? (
                                                <p className='font-size-14' style={{}}>{item.title.length < 13 ? item.title : item.title.substring(0, 10) + '...'}</p>
                                            ) : ''}
                                        </div>
                                    </div>
                                    <p className='font-size-14 m-2' style={{}}>{this.props.showDate(item.schedule?.startTime, true)}</p>
                                    <div>
                                        <button className='flexcc' >
                                            <img src='/assets/icons/rooms/cancel.svg' width={16} />
                                        </button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default RoomSchedule;